import { CoreTypography } from '@youscience/core';
import { RouteObject } from 'react-router-dom';
import { ecpOrganizationsLoaderType } from '@features/ecp/interfaces/ecpLoaderTypes';
import ErrorPage from '../error-page';
import { ECP_ROUTES, ORGANIZATION_ROUTES } from '.';
import { ECP_SETTINGS_ENABLED, SUNSET_ECP_ENABLED } from '../constants/env';
import { commonTenantBreadCrumbs } from './commonBreadcrumbs';
// Lazy components

const allEcpRoutes: RouteObject[] = [
  {
    path: ECP_ROUTES.ECP_SETTINGS_INDEX,
    children: [
      {
        async lazy() {
          const { EcpSettings } = await import('@features/ecp/EcpSettings/EcpSettings');

          if (!ECP_SETTINGS_ENABLED) {
            window.location.replace(ORGANIZATION_ROUTES.ORGANIZATIONS);
          }

          return { Component: ECP_SETTINGS_ENABLED ? EcpSettings : ErrorPage };
        },
        errorElement: <ErrorPage />,
        async loader({ request, params }) {
          const { ecpSettingsLoader } = await import('@features/ecp/loaders');

          return ecpSettingsLoader({ request, params });
        },
        index: true,
        handle: {
          crumb: ({ tenant }: ecpOrganizationsLoaderType) => {
            const tenantId = tenant?.tenantId ?? '';
            const tenantName = tenant?.name ?? '';

            return [
              ...commonTenantBreadCrumbs(tenantId, tenantName),
              <CoreTypography color='text.secondary'>ECP</CoreTypography>,
            ];
          },
        },
      },
      {
        async lazy() {
          const { CoursePlannerSettings } = await import('@features/ecp/CoursePlannerSettings/CoursePlannerSettings');

          return { Component: CoursePlannerSettings };
        },
        errorElement: <ErrorPage />,
        async loader({ request, params }) {
          const { ecpSettingsLoader } = await import('@features/ecp/loaders');

          return ecpSettingsLoader({ request, params });
        },
        path: ECP_ROUTES.CONFIGURE_COURSE_PLANNER,
        handle: {
          crumb: ({ tenant }: ecpOrganizationsLoaderType) => {
            const tenantId = tenant?.tenantId ?? '';
            const tenantName = tenant?.name ?? '';

            return [
              ...commonTenantBreadCrumbs(tenantId, tenantName),

              <CoreTypography color='text.secondary'>Configure course planner</CoreTypography>,
            ];
          },
        },
      },
    ],
  },
];

export const ecpRoutes: RouteObject[] = SUNSET_ECP_ENABLED ? [] : allEcpRoutes;
